import React from 'react';

import { SVGComponentProps } from './svg.types';

const NextMediaSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.8411 8.15713C12.4586 8.55008 12.4586 9.4515 11.8411 9.84445L1.87037 16.1894C1.20465 16.6131 0.333496 16.1349 0.333496 15.3458L0.333496 2.6558C0.333496 1.8667 1.20465 1.38849 1.87037 1.81213L11.8411 8.15713Z"
          fill={fill}
        />
        <rect
          width="2.33333"
          height="16.3333"
          rx="1"
          transform="matrix(1 0 0 -1 14.3335 17.167)"
          // fill="#55585E"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default NextMediaSVG;
